import {
  getRelativeFontSize,
  boldFont,
  PrimaryTextColor,
  regularFont,
  heading,
  PrimaryLightTextColor,
} from "../../../../../utils/styles";

const SalaryInformationStyles = {

  pageInfoHeader: {
    position: "absolute",
    left: "115px",
    top: "10px",
  },

  Heading: {
    ...boldFont,
    fontSize: getRelativeFontSize(10),
  },

  CheckLabel: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(),
    ...regularFont,
  },

  text: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },

  header: {
    paddingBottom: "20px ",
  },
  pageHeading: {
    fontSize: getRelativeFontSize(2),
    ...boldFont,
    color: PrimaryTextColor,
  },
  pageText: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },
  avtarStyle: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    border: "4px solid #ECEDFC",
    //  overflow: "hidden",
    padding: "5px",
    position: " relative",
    "& img": {
      width: "100%",
      height: " auto",
      overflow: "hide",
    },
  },

  uploadIcon: {
    position: " absolute",
    bottom: "-15px",
    right: "-10px",
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    background: "#ECEDFC",
  },
  custombuttonStyle: {
    width: "200px",
  },
  label: {
    ...regularFont,
    fontSize: getRelativeFontSize(0),
    wordSpacing: "2px",
    color: PrimaryTextColor,
  },
  autocomplateStyle: {
    width: '100%',
    background: '#fffff',
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(2),
      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(-1),
        color: PrimaryLightTextColor,
      },
    },
    '&  .MuiOutlinedInput-root': {
      padding: '4px 9px',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      '&.Mui-focused fieldset': {
        borderColor: '#E7E7EA',
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    '& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
      borderColor: '#E7E7EA',
    },
  },

  detailsHeading: {
    ...heading,
    fontSize: getRelativeFontSize(2),
  },
  
  buttonWrapper: {
    display: "flex",
    gap : "50px",
    marginTop  : "30px"
  },
  salaryContainer:{
    "& .MuiFormControlLabel-root":{
      margin:"10px 0 0 0",
    },
    "& .MuiButtonBase-root":{
      padding:"0",
      marginRight:"10px",
    },
    "& .MuiFormControlLabel-label":{
      ...regularFont,
      fontSize: getRelativeFontSize(0),
    },
  },
};

export default SalaryInformationStyles;
